<template>
  <div id="login">
    <div class="header">
      <div class="inner">
        <router-link :to="{ name: 'Home' }">
          <img :src="logourl" onerror="src='/static/img/logo.png'" />
          <!-- <img  src='/static/img/logo.png' onerror="src='/static/img/logo.png'" /> -->
        </router-link>
        <span>您好，欢迎登录{{ $store.state.webInfo.name }}商城！</span>
      </div>
    </div>
    <div
      class="conter"
      :style="{
        backgroundImage:
          'url(' +
          ($store.state.webInfo.mall_login_bg == ''
            ? '/static/img/pclogos.jpg'
            : $store.state.webInfo.mall_login_bg) +
          ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }"
    >
      <div class="bg">
        <!-- <img
                        :src="$store.state.webInfo.mall_login_bg==''?'/static/img/pclogos.png':$store.state.webInfo.mall_login_bg"
                        class="xy-middle "
                        style="width:auto"
                        > -->
      </div>
      <div class="inner">
        <div
          class="login-box"
          style="position:absolute; right: 80px;top: 80px;"
        >
          <vLogin></vLogin>
        </div>
      </div>
    </div>
    <div>
      <el-footer style=" background: #ffffff;height:183px;padding:0;">
        <vLoginFooter></vLoginFooter>
      </el-footer>
    </div>
  </div>
</template>
<script>
import vFooter from "@/common/footer";
import vLogin from "@/common/login";
import vLoginFooter from "@/common/login-footer";
export default {
  name: "login",
  components: {
    vFooter,
    vLogin,
    vLoginFooter
  },
  data() {
    return {
      activeName: "first",
      logourl: this.$store.state.webInfo.logo_pc
    };
  },
  created() {
    // console.log(this.$route.name)
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  border-radius: 6px;
  overflow: hidden;
}
#login {
  min-width: 1200px;
  min-height: 100vh;
  position: relative;
  .header {
    background: #ffffff !important;
    box-shadow: 0px -7px 13px 0px rgba(110, 110, 110, 0.1);
    .inner {
      width: 1200px;
      padding-top: 10px;
      padding-bottom: 10px;
      margin: auto;
      line-height: 57px;
      display: flex;
      justify-content: space-between;
    }
    height: 80px;
    background: white;
    text-align: left;
    img {
      vertical-align: bottom;
      width: auto;
      max-height: 60px;
      max-width: 200px;
    }
    span {
      display: inline-block;
      font-size: 16px;
      margin-left: 20px;
      color: rgba(38, 38, 38, 0.5);
    }
  }
  .conter {
    // background: url('/static/img/pclogos.png') no-repeat;
    height: 700px;
    position: relative;
    .inner {
      width: 1200px;
      margin: auto;
      position: relative;
    }
    .bg {
      // background: url('/static/img/login.png') no-repeat;
      overflow: hidden;
      background-size: 83%;
      position: absolute;
      width: 100%;
      height: 670px;
    }
    .form {
      position: absolute;
      top: 50px;
      right: 100px;
      width: 352px;
      height: 446px;
      background: white;
    }
  }
  .inputbox {
    // margin: 40px;
    width: 278px;
    height: 38px;
    border: 1px solid rgba(230, 231, 231, 1);
    padding: 0 15px;
    box-sizing: border-box;
    input {
      width: 100%;
      line-height: 34px;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue